<template>
    <div :class="{'en': lang === 'en'}">
        <div class="card-title">
            {{type === "add" ? $t("lang.create_fixed_trust_account") : $t("lang.update_fixed_trust_account")}}
        </div>
        <vs-row class="m-t-1">
            <vs-col vs-w="6">
                <div class="input-group">
                    <vs-input v-model="fixedTrustAccount.fixedNumber" style="width: 100%" :placeholder="$t('lang.fixed_custody_number')"></vs-input>
                </div>
            </vs-col>
            <vs-col vs-w="6">
                <div class="input-group">
                    <datepicker class="fixedPicker" v-model="fixedTrustAccount.date" :placeholder="$t('lang.effective_date')" :format="format"
                            :highlighted="highlight"></datepicker>
                </div>
            </vs-col>
            <vs-col vs-w="6">
                <div class="input-group">
                    <datepicker class="fixedPicker" v-model="fixedTrustAccount.maturityDate" :placeholder="$t('lang.maturity_date')" :format="format"
                            :highlighted="highlight"></datepicker>
                </div>
            </vs-col>
        </vs-row>
        <vs-row class="m-t-1">
            <vs-col vs-w="6">
                <div class="input-group">
                    <vs-input v-model="fixedTrustAccount.currency" style="width: 100%" :placeholder="$t('lang.management_currency')"></vs-input>
                </div>
            </vs-col>
            <vs-col vs-w="6">
                <div class="input-group">
                    <vs-input v-model="fixedTrustAccount.trustAmount" style="width: 100%" :placeholder="$t('lang.custody_amount')" type="number"></vs-input>
                </div>
            </vs-col>
        </vs-row>
        <vs-row class="m-t-1">
            <vs-col vs-w="6">
                <div class="input-group">
                    <vs-input v-model="fixedTrustAccount.expectedReturn" style="width: 100%" :placeholder="$t('lang.standard_return')"></vs-input>
                </div>
            </vs-col>
            <vs-col vs-w="6">
                <div class="input-group">
                    <vs-input v-model="fixedTrustAccount.livingBeneficiary" style="width: 100%" :placeholder="$t('lang.beneficiary')"></vs-input>
                </div>
            </vs-col>
        </vs-row>
        <vs-row class="m-t-1">
            <vs-col vs-w="6">
                <div class="input-group">
                    <vs-input v-model="fixedTrustAccount.deathBeneficiary" style="width: 100%" :placeholder="$t('lang.beneficiary_after_death')"></vs-input>
                </div>
            </vs-col>
            <vs-col vs-w="6">
                <div class="input-group">
                    <vs-input v-model="fixedTrustAccount.note" style="width: 100%" :placeholder="$t('lang.note')"></vs-input>
                </div>
            </vs-col>
        </vs-row>
        <vs-row class="m-t-1">
            <vs-col vs-w="6">
                <vs-select v-model="fixedTrustAccount.depositOrWithdrawal" autocomplete :placeholder="$t('lang.deposit_withdrawal')" style="width: 100%">
                    <vs-select-item value="lang.deposit" :text="$t('lang.deposit')" />
                    <vs-select-item value="lang.withdrawal" :text="$t('lang.withdrawal')" />
                </vs-select>
            </vs-col>
            <vs-col vs-w="6">
                <div class="input-group">
                    <vs-input v-model="fixedTrustAccount.amount" style="width: 100%" type="number" :placeholder="$t('lang.amount')"></vs-input>
                </div>
            </vs-col>
        </vs-row>
        <vs-row class="m-t-1">
            <vs-col vs-w="6">
                <div class="input-group">
                    <vs-input v-model="fixedTrustAccount.initialDeposit" type="number" style="width: 100%" :placeholder="$t('lang.initial_deposit')"></vs-input>
                </div>
            </vs-col>
            <vs-col vs-w="6">
                <div class="input-group">
                    <vs-input v-model="fixedTrustAccount.interestDeposit" type="number" style="width: 100%" :placeholder="$t('lang.interest_deposit')"></vs-input>
                </div>
            </vs-col>
        </vs-row>
        <vs-row class="m-t-2">
            <vs-col vs-w="12" vs-type="flex" vs-justify="center">
                <vs-button v-if="type !== 'add' " size="small" color="rgb(37, 105, 193)" class="stribtn m-r-1" @click="onUpdate()">{{$t('message.submit')}}</vs-button>
                <vs-button v-else size="small" color="rgb(37, 105, 193)" class="stribtn m-r-1" @click="onAdd()">{{$t('message.submit')}}</vs-button>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
export default {
    props: ["data", "type"],
    components: {
        Datepicker,
    },
    data(){
        return{
            lang: '',
            token: '',
            format: 'dd / MM / yyyy',
            highlight: {
                customPredictor(date) {
                    if ((date.getDate() - new Date().getDate() == 0) && (date.getMonth() - new Date().getMonth() == 0))
                        return true;
                }
            },
            fixedTrustAccount: { ...this.data },
        }
    },
    created() {
        this.lang = this.$cookies.get('lang');
        this.token = this.$cookies.get('token');
    },
    watch:{
        "data"(newVal){
            this.fixedTrustAccount = newVal;
        },
    },
    methods: {
        onUpdate(){
            this.$emit("update", this.fixedTrustAccount);
        },
        onAdd(){
            this.$emit("add", this.fixedTrustAccount);
        }
    },
}
</script>

<style scoped>
.input-group {
    flex-wrap: nowrap;
    align-items: center;
    margin-bottom: 10px;
}
label{
    margin-bottom: 0;
    white-space: nowrap;
    width: 100px;
}
.en label{
    width: 180px;
}
</style>
